import { z } from '@hono/zod-openapi'

// id
export const idZ = z
  .number()
  .openapi({ description: '運用ルールID', example: 1 })
export type id = z.infer<typeof idZ>

// ownerId: オーナーID
export const ownerIdZ = z.string().openapi({
  description: 'オーナーID',
  example: '00000000-0000-0000-0000-000000000000',
})
export type ownerId = z.infer<typeof ownerIdZ>

// propertyId: 物件ID(NULL可。NULL=オーナー既定ルール、値あり=物件固有ルール)(E-13)
export const propertyIdZ = z.number().nullable().openapi({
  description: '物件ID。null はオーナー既定ルール、値ありは物件固有ルール',
  example: 1,
})
export type propertyId = z.infer<typeof propertyIdZ>

// エージェントコール業者の手配について
export const AGENTCALL_CONSENT_AGREE = 'agree'
export const AGENTCALL_CONSENT_DISAGREE = 'disagree'

export const agentCallConsentZ = z.enum([
  AGENTCALL_CONSENT_AGREE,
  AGENTCALL_CONSENT_DISAGREE,
])
export type AgentCallConsent = z.infer<typeof agentCallConsentZ>

// agentCallContractorApproval: エージェントコール業者手配承諾
export const agentCallContractorApprovalZ = agentCallConsentZ.openapi({
  description:
    'エージェントコール業者による手配の承諾可否（agree:承諾する / disagree:承諾しない）',
  example: 'disagree',
})
export type agentCallContractorApproval = z.infer<
  typeof agentCallContractorApprovalZ
>

// 指定業者の有無
export const DESIGNATED_CONTRACTOR_EXISTS = 'exists'
export const DESIGNATED_CONTRACTOR_NONE = 'none'

export const designatedContractorStatusZ = z.enum([
  DESIGNATED_CONTRACTOR_EXISTS,
  DESIGNATED_CONTRACTOR_NONE,
])
export type DesignatedContractorStatus = z.infer<
  typeof designatedContractorStatusZ
>

// hasDesignatedContractor: 指定業者の有無
export const hasDesignatedContractorZ = designatedContractorStatusZ.openapi({
  description: 'オーナー指定業者の有無（exists:あり / none:なし）',
  example: 'exists',
})
export type hasDesignatedContractor = z.infer<typeof hasDesignatedContractorZ>

// 手配上限金額オプション
export const ARRANGEMENT_LIMIT_ALL_ESTIMATE = 'all_estimate'
export const ARRANGEMENT_LIMIT_30000 = '30000'
export const ARRANGEMENT_LIMIT_50000 = '50000'
export const ARRANGEMENT_LIMIT_70000 = '70000'
export const ARRANGEMENT_LIMIT_100000 = '100000'
export const ARRANGEMENT_LIMIT_CONFIRM_REQUIRED = 'confirm_required'

export const arrangementLimitBaseZ = z.enum([
  ARRANGEMENT_LIMIT_ALL_ESTIMATE,
  ARRANGEMENT_LIMIT_30000,
  ARRANGEMENT_LIMIT_50000,
  ARRANGEMENT_LIMIT_70000,
  ARRANGEMENT_LIMIT_100000,
  ARRANGEMENT_LIMIT_CONFIRM_REQUIRED,
])
export type ArrangementLimit = z.infer<typeof arrangementLimitBaseZ>

// arrangementLimit: 手配上限金額
export const arrangementLimitZ = arrangementLimitBaseZ.nullable().openapi({
  description:
    '業者手配を任せられる上限金額（all_estimate:全件見積を取る / 30000・50000・70000・100000:上限額(円) / confirm_required:都度確認）',
  example: '50000',
})
export type arrangementLimit = z.infer<typeof arrangementLimitZ>

// createdAt: 作成日時
export const createdAtStringZ = z.string().openapi({
  description: '作成日時（ISO8601）',
  example: '2024-01-01T00:00:00.000Z',
})
export type createdAtString = z.infer<typeof createdAtStringZ>

export const createdAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type createdAtDate = z.infer<typeof createdAtDateZ>

// updatedAt: 更新日時
export const updatedAtStringZ = z.string().openapi({
  description: '更新日時（ISO8601）',
  example: '2024-01-01T00:00:00.000Z',
})
export type updatedAtString = z.infer<typeof updatedAtStringZ>

export const updatedAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type updatedAtDate = z.infer<typeof updatedAtDateZ>
